// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__4+ptO","icon__danger":"styles_icon__danger__FsCN1","icon__info":"styles_icon__info__Rzp6O"};